// import axios from "@/axios"; 
import axiosSync from "@/axiosSync";
// import axios from "@/axios";

export function usePortInfoVsolEponApi() {
  async function getBasicInfo(olt_id) {
    const response = await axiosSync.get(`/vsol-epon?type=device_info&oltid=${olt_id}&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getPonPortData(olt_id) {
    const response = await axiosSync.get(`/vsol-epon?type=poninfo&oltid=${olt_id}&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getUpLinkData(olt_id) {
    const response = await axiosSync.get(`/vsol-epon?type=uplinkport_status&oltid=${olt_id}&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getSingleOnuData(port_number, olt_id) {
      console.log('VSOL Service - Processing:', { port_number, olt_id });
      const matches = port_number.match(/(GPON|EPON)?\d*\/(\d+):(\d+)/i);
      
      if (!matches) {
        throw new Error(`Invalid port number format: ${port_number}. Expected format like GPON0/1:1 or EPON1/1:1`);
      }
      
      const ponid = matches[2];  // The part after / and before :
      const onuid = matches[3];  // The part after :
      
      console.log('VSOL Service - Parsed:', { ponid, onuid });
      
      const url = `vsol-epon?type=single_onudata&pon=${ponid}&onu=${onuid}&oltid=${olt_id}&url=${process.env.VUE_APP_API_BASE_URL}`;
      console.log('VSOL Service - API URL:', url);
      
      const response = await axiosSync.get(url);
      console.log('VSOL Service - Response received');
      
      return response.data;
  }


  return {
    getBasicInfo,
    getPonPortData,
    getUpLinkData,
    getSingleOnuData
  };
}
